import { render, staticRenderFns } from "./FormCouponCatalog.vue?vue&type=template&id=7a108f5c&"
import script from "./FormCouponCatalog.vue?vue&type=script&lang=js&"
export * from "./FormCouponCatalog.vue?vue&type=script&lang=js&"
import style0 from "./FormCouponCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports